import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { ICompany } from '../../../../shared/model/company.model';
import { ConfirmDialogComponent, IConfirmData } from '../../../../shared/components/confirm-dialog/confirm-dialog.component';
import { IBankAccount } from '../../../../shared/model/bank-account.model';
import { BankAccountService } from '../../../../shared/services/bank-account.service';
import { IconService } from '../../../../shared/services/icon.service';
import { switchMap } from 'rxjs/operators';
import { CompanyService } from '../../../../shared/services/company.service';
import { BankAccountPermission } from '../../../../shared/model/bank-account-permission';
import { PermissionService } from 'src/app/shared/services/permission.service';

@Component({
  selector: 'app-details',
  templateUrl: './details.page.html',
  styleUrls: ['./details.page.scss']
})
export class DetailsPage implements OnInit, OnDestroy {

  public bankAccount$!: Observable<IBankAccount>;
  public company$!: Observable<ICompany>;
  public canEditBankAccount$!: Observable<boolean>;

  private dialogSubscription: Subscription | undefined;

  constructor(
    private permissionService: PermissionService,
    private bankAccountService: BankAccountService,
    private companyService: CompanyService,
    private route: ActivatedRoute,
    private iconService: IconService,
    private router: Router,
    private dialog: MatDialog,
  ) {
    this.iconService.loadIcons([
      'checked',
      'edit',
      'delete',
      'settings',
      'users',
    ]);
  }

  public ngOnInit(): void {
    const id = Number(this.route.snapshot.paramMap.get('bankAccountId'));
    if (id) {
      this.bankAccount$ = this.bankAccountService.get(id);
      this.company$ = this.bankAccount$.pipe(
        switchMap((bankAccount) => this.companyService.get(bankAccount.companyId)),
      );
      this.canEditBankAccount$ = this.permissionService.hasBankAccountPermission(Number(id), BankAccountPermission.EDIT);
    }
  }

  public ngOnDestroy(): void {
    this.dialogSubscription?.unsubscribe();
  }

  public toggleActive(bankAccount: IBankAccount): void {
    bankAccount.active = !bankAccount.active;
    this.bankAccountService.update(bankAccount);
  }

  public showDeleteDialog(bankAccount: IBankAccount): void {
    const data: IConfirmData = {
      title: `Delete bank account "${bankAccount.name}"?`,
      message: 'This will delete the bank account with all it\'s data and cannot be undone.'
    };
    const dialog = this.dialog.open(ConfirmDialogComponent, { data });
    this.dialogSubscription = dialog.afterClosed().subscribe((confirm) => {
      if (confirm) {
        this.delete(bankAccount);
      }
    });
  }

  public delete(bankAccount: IBankAccount): void {
    this.bankAccountService.delete(bankAccount).then(() => {
      this.router.navigate(['/companies', bankAccount.companyId]);
    });
  }

}
